<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <div v-if="!loading">
      <form-wizard color="#B1D06C" :title="null" :subtitle="null" shape="square" finish-button-text="Submit"
        back-button-text="Previous" class="mb-3" @on-complete="formSubmitted" ref="formWiz">
        <!-- Search details tab -->
        <tab-content title="Details" :before-change="ValidateRawMaterials">
          <addproduct @formUpdate="getRawData" ref="RawMaterialDetails" />
        </tab-content>
        <!-- <tab-content title="Reorder Criteria" :before-change="validateReorderCriteria">
          <addReorderCriteria  @reorderingUpdate="reorderingUpdate" ref="addProductReorderCriteria" />
        </tab-content> -->
        <tab-content title="Finish">
          <b-container class="d-flex justify-content-center last_step flex-column">
            <img src="./check-mark.svg" style="height: 200px" alt="" />
            <h2 class="text-center mt-3 text-primary">Submit and Confirm</h2>
          </b-container>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import addproduct from "./addproduct.vue";
// import addReorderCriteria from "./addReorderCriteria.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapActions, mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BContainer,
  BCard,
  BSpinner,
} from "bootstrap-vue";

export default {
  components: {
    FormWizard,
    BContainer,
    BButton,
    BFormCheckbox,
    BCard,
    TabContent,
    BRow,
    BCol,
    ToastificationContent,
    BSpinner,
    addproduct
  },
  data() {
    return {
      productFile: null,
      totalBomCost: 0,
      totalOperationCost: 0,
      qualityItems: [],
      rawmaterial: [],
    };
  },
  computed: {
    ...mapGetters("productModule", {
      loading: "loading",
    }),
  },

  methods: {
    ...mapActions("productModule", ["addProductAction"]),
    ...mapActions("rawmaterialModule", ["addRawMaterialAction"]),
    // async validateReorderCriteria() {
    //   // Access the child component and trigger its validation
    //   const isValid = await this.$refs.addProductReorderCriteria.submitForm();
    //   return isValid;
    // },

    neckStep() {
      this.$refs.formWiz.nextTab();
    },
    ValidateRawMaterials(){
      let isValid = this.$refs.RawMaterialDetails.formValidation().then((res) => isValid = res);
      return isValid;
    },
    getRawData(data) {
      this.rawmaterial = data;
    },
    reorderingUpdate(data) {

      console.log(data);
      this.rawmaterial.reordering = data;
    
    },


    success() {
      this.$swal({
        title: "Raw Material Added!",
        text: "You have successfully added the raw material!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: "rawmaterials-list" });
        }
      });
    },

    // error
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        //text: msg ?? ' Failed!',
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    formSubmitted() {
      this.$swal({
        title: 'Processing...',
        text: 'Please wait while the data is being submitted...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });

      console.log("this.rawmaterial.lowStock ", this.rawmaterial.lowStock);

      let payload = {
        name: this.rawmaterial.name,
        description: this.rawmaterial.description,
        categoryID: this.rawmaterial.categoryID,
        productCategorySubId: this.rawmaterial.ProductCategorySubId,
        code: this.rawmaterial.code,
        supplierId: this.rawmaterial.supplierId,
        lowStock: this.rawmaterial.lowStock,
        defaultUomID: this.rawmaterial.defaultUomID,
        purchasePrice: this.rawmaterial.purchasePrice,
        reordering: this.rawmaterial.reordering,
        additionalFields: this.rawmaterial.additionalFields
      };

      console.log("payload", payload);

      this.addRawMaterialAction(payload)
        .then(() => {
          this.$swal.close(); // Close swal after successful action
          this.success();
        })
        .catch((error) => {
          this.$swal.close(); // Close swal in case of an error
          this.error(error.response.data);
        });
    }

  },

};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}
</style>
